import React, { useEffect, useState } from 'react';
import AssetCard from 'components/cards/AssetCard';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateLoading, updateTitle } from 'store/app';
import { getAssets } from 'store/asset';

const Assets = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { list } = useSelector(state => state.asset);

  const [loading, setLoading] = useState(true);

  const fetchList = () => {
    dispatch(getAssets())
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchList();
    dispatch(updateTitle(t('asset.all')))
  }, [])

  if (loading || !list) {
    return (
      <div className="px-8 grid grid-cols-2 gap-5 overflow-y-scroll pb-6 animate-pulse">
        <div className="h-32 bg-gray-300 rounded-lg w-full" />
        <div className="h-32 bg-gray-300 rounded-lg w-full" />
        <div className="h-32 bg-gray-300 rounded-lg w-full" />
        <div className="h-32 bg-gray-300 rounded-lg w-full" />
      </div>
    );
  }

  return (
    list &&
    <div className="h-full w-full px-8">
      <div className="grid grid-cols-2 gap-5">
        {list && list.length > 0
          ?
          list.map((item, index) =>
            <AssetCard key={index} asset={item} className="w-full" />
          )
          :
          <span>
            {t('asset.no_available')}
          </span>
        }
      </div>
    </div>
  )
}

export default Assets;